export default __webpack_public_path__ + "static/media/main-music.2b9127d1.mp3";